import { useQuery } from '@tanstack/react-query';
import { mapToAutoPaySummary, memberInfoKey, requestMyMemberInfo } from './memberInfoApi';

/**
 * The member's real AutoPay enrollment status, amount, and payment plan. Shares the
 * `myMemberInfo` query/cache with {@link useMemberBillingProfile} — same key, different `select`.
 */
export function useMemberAutoPaySummary() {
  return useQuery({
    queryKey: memberInfoKey,
    queryFn: requestMyMemberInfo,
    select: mapToAutoPaySummary,
  });
}
